import { Injectable } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders} from "@angular/common/http";
import {AppSettings} from './AppSettings';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { ResultModel } from '../services/tPatient.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private fb: FormBuilder,private http:HttpClient) { }

  readonly BaseURI = AppSettings.BaseURI;

  formModel = this.fb.group({
    UserName: ['', Validators.required],
    Email: ['', Validators.email],
    FullName: ['', Validators.required],
    Passwords: this.fb.group({
      Password: ['', [Validators.required, Validators.minLength(4)]],
      ConfirmPassword: ['', Validators.required]
    }, { validator:  this.comparePasswords })

  });


  comparePasswords(fb: FormGroup) {
    let ConfirmPasswordCtrl = fb.get('ConfirmPassword');
    if (ConfirmPasswordCtrl.errors == null || 'passwordMismatch' in ConfirmPasswordCtrl.errors) {
      if (fb.get('Password').value != ConfirmPasswordCtrl.value) {
        ConfirmPasswordCtrl.setErrors({ passwordMismatch: true });
      }else{
        ConfirmPasswordCtrl.setErrors(null);
      }
    }
  }

  registerApplicationUser(){
    var body = {
      UserName: this.formModel.value.UserName,
      Email: this.formModel.value.Email,
      FullName: this.formModel.value.FullName,
      Password: this.formModel.value.Passwords.Password,
      EmployeeRoleID: 0
    };

    return this.http.post(this.BaseURI+'/ApplicationUser/Register',body);
  }


  login(formData){
    var loginModel = {
      UserName: formData.UserName,
      Password: formData.Password
    };

    return this.http.post(this.BaseURI+'/ApplicationUser/Login',loginModel);
  }

  logout(userID:String){
    // var userID;

    var userIDModel = {
      userID: userID
    };
    return this.http.post(this.BaseURI+'/ApplicationUser/Logout',userIDModel);
  }


  removeLoginAuth(userID:String){
    // var userID;

    var userIDModel = {
      userID: userID
    };
    return this.http.post(this.BaseURI+'/ApplicationUser/RemoveLoginAuth',userIDModel);
  }

  getUserProfile(){
    return this.http.get(this.BaseURI+'/UserProfile').pipe(shareReplay(1));
  }

  getUserInfoById(id:String){
    return this.http.get<ResultModel>(this.BaseURI+'/ApplicationUser/users/'+id).pipe(shareReplay(1));
  }

  changeShopID(shopID:number){
    return this.http.get(this.BaseURI+'/ApplicationUser/changeShopID/'+shopID).pipe(shareReplay(1));
  }

  getSystemDecimalPlace(){
    return this.http.get(this.BaseURI+'/SystemDecimalPlace');
  }

  putSystemDecimalPlaceAll(formData){
    return this.http.put(this.BaseURI+'/SystemDecimalPlace',formData);
  }

  putSystemDecimalPlaceByRow(id,formData){

    return this.http.put(this.BaseURI+'/SystemDecimalPlace'+'/'+id,formData);
  }


  GetUnauthorizedReason(token:String){
    // var userID;

    var checkUnauthorizedModel = {
      token: token
    };
    return this.http.post(this.BaseURI+'/ApplicationUser/GetUnauthorizedReason',checkUnauthorizedModel);
  }

}
